import { connect } from 'react-redux';
import withImmutablePropsToJS from 'with-immutable-props-to-js';
import { updateSelectedTemplate } from '../../../../../store/actions/receiveMessage.action';
import { IStateType } from '../../../../../store/models/root.interface';
import { closeSideBar } from '../../../../../store/sidebar';
import SelectTemplate, {
    DispatchPropsType,
    MapStateType,
    OwnProps
} from '../../organisms/receiveMessage/selectTemplate';

const mapStateToProps = (state: IStateType) => ({
    templatesData: state.sidebar.params
});

const mapDispatchToProps = (dispatch: any) => ({
    onClose: () => dispatch(closeSideBar()),
    updateSelectedTemplateInStore: (templateId: string) => dispatch(updateSelectedTemplate(templateId))
});

export default connect<MapStateType, DispatchPropsType, OwnProps, IStateType>(
    mapStateToProps,
    mapDispatchToProps
)(withImmutablePropsToJS(SelectTemplate));
